define('lib/Podio.UI',['require','jquery','underscore'],function(require) {

  var $ = require('jquery');
  var _ = require('underscore');

  var keyCodes = {
      Esc: 27,
      Return: 13,
      DownArrow: 40,
      UpArrow: 38,
      LeftArrow: 37,
      RightArrow: 39,
      Space: 32,
      Shift: 16,
      Tab: 9,
      BackSpace: 8
  };

  var context;

  function disableButtonWithLoader(elmButton) {
    elmButton.prop('disabled', true);
    elmButton.addClass('loader');
  }

  function restoreButtonWithLoader(elmButton) {
    elmButton.prop('disabled', false);
    elmButton.removeClass('loader');
  }

  function disableInputField(elmInput) {
    elmInput.prop('disabled', true);
    elmInput.addClass('disabled');
  }

  function restoreInputField(elmInput) {
    elmInput.prop('disabled', false);
    elmInput.removeClass('disabled');
  }

  function setContext(context_type, context_id) {
    context = {
      context_type: context_type,
      context_id: context_id
    };
  }

  function clearContext() {
    context = null;
  }

  function getContext() {
    if(_.isUndefined(context)) {
      context = null;
      
      var elmWrapper = $('#wrapper');

      if(elmWrapper.length) {
        var context_type = elmWrapper.data('context-type');
        var context_id = elmWrapper.data('context-id');
        if (_.isString(context_type) && _.isNumber(context_id)) {
          context = {
            context_type: context_type,
            context_id: context_id
          };
        }
      }
    }
    
    return context;
  }

  function limitTabbingToElement(elmTarget) {

    elmTarget.bind("keydown", function( e ) {
      if ( e.keyCode !== keyCodes.Tab ) {
        return;
      }

      var elmTabbables = $(':tabbable', elmTarget),
          elmFirstTab = elmTabbables.filter(':first'),
          elmLastTab  = elmTabbables.filter(':last');

      if ( e.target === elmLastTab[0] && !e.shiftKey ) {
        elmFirstTab.focus();
        return false;
      } else if ( e.target === elmFirstTab[0] && e.shiftKey ) {
        elmLastTab.focus();
        return false;
      }

    });
  }

  function isAttachedToDom(elmTarget) {
    var elm = elmTarget instanceof $ ? elmTarget[0] : elmTarget;

    return $.contains(document, elm);
  }

  return {
    KeyCodes: keyCodes,
    disableButtonWithLoader: disableButtonWithLoader,
    restoreButtonWithLoader: restoreButtonWithLoader,
    disableInputField: disableInputField,
    restoreInputField: restoreInputField,
    context: getContext,
    setContext: setContext,
    clearContext: clearContext,
    limitTabbingToElement: limitTabbingToElement,
    isAttachedToDom: isAttachedToDom
  };

});


